import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { Sc4FailedMessagesListSearchCriteria, Sc4FailedMessagesModel } from '../../models';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';
import { isEmpty } from 'lodash';
import { removeEmptyValueFromObj } from '../../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class Sc4FailedMessagesListService {
  constructor(private http: WrapperHttpService) {}

  getSc4FailedMessagesList({
    size,
    page,
    ...rest
  }: Sc4FailedMessagesListSearchCriteria): Observable<Sc4FailedMessagesModel[]> {
    const transactionDateTime = removeEmptyValueFromObj({
      ...rest.transactionDateTime,
      start: rest.transactionDateTime?.start ? new Date(rest.transactionDateTime.start).getTime() : null,
      end: rest.transactionDateTime?.end ? new Date(rest.transactionDateTime.end).getTime() : null,
    });
    const filter = removeEmptyValueFromObj({
      ...rest,
      transactionDateTime: isEmpty(transactionDateTime) ? null : transactionDateTime,
    });
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Sc4}${FailedMessagesEndpoint.FailedTransaction}`;
    return this.http.withLoading().post<Sc4FailedMessagesModel[]>(url, { size, page, filter });
  }
}
